  <a *ngIf="item"
    mat-list-item
    [ngStyle]="{'padding-left': (depth * 12) + 'px'}"
    (click)="onItemSelected(item)"
    [ngClass]="{'active': item.route ? router.isActive(item.route, true): false, 'expanded': expanded}"
    class="menu-list-item"
    matTooltip="{{item.displayName | translate}}"
    matTooltipPosition="right"
    matTooltipClass="larger-tooltip">
  <mat-icon class="routeIcon">{{item.iconName}}</mat-icon>
  <div  class="display-name">{{item.displayName | translate}}</div>
  <span class="expander" *ngIf="item.children && item.children.length">
    <mat-icon [@indicatorRotate]="expanded ? 'expanded': 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <gt-navigation-item *ngFor="let child of item.children" [item]="child" [depth]="depth+1">
  </gt-navigation-item>
</div>
